import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Input } from "reactstrap";
import "./promotion.scss";
import TicketIcon from "../../assets/images/TicketIcon.png";
import searchIcon from "../../assets/images/search-normal.png";
import FilterIcon from "../../assets/images/filter-icon.png";
import editIcon from "../../assets/images/EditBlueIcon.png";
import settingIcon from "../../assets/images/settingBlueIcon.png";
import duplicateIcon from "../../assets/images/copyBlueIcon.png";
import { useEffect, useState } from "react";
import DeactiveModal from "./Components/DeactiveModal";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { activateVoucher, getVouchersThunk } from "live-slices/voucher/thunk";
import ErrorModal from "Components/Common/ErrorModal";

const PromotionListing = (props: any) => {
  const { loading, data, error } = useSelector((state: any) => state.vouchers);
  const page = 1;
  const count = 20;
  const keywordType = "";
  const [keyword, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const dispatch = useDispatch<any>();
  const [errorMessage, setErrorMessage] = useState<string>("");
    const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  
  
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

 useEffect(() => {
  const handler = setTimeout(async () => {
    try {
      const res = await dispatch(
        getVouchersThunk({
          page:currentPage,
          count: itemsPerPage,
          keyword,
          keywordType,
          status,
        })
      );
      const total = res.payload?.totalCount || 0;
      setTotalCount(total);
    } catch (error) {
      console.error("Error fetching vouchers:", error);
    }
  }, 500);

  return () => clearTimeout(handler); // cleanup
}, [dispatch, page, count, keyword, keywordType, status,currentPage, itemsPerPage]);

  console.log("data:", data);

  const [deActiveModal, setdeActiveModal] = useState(false);

      const handleItemsPerPageChange = (e:any) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to page 1 when count changes
  };



  const handleToggle = (id: any) => {
    dispatch(activateVoucher({ id }))
      .then(() => {
        dispatch(
          getVouchersThunk({
            page,
            count,
            keyword,
            keywordType,
            status,
          })
        );
      })
      .catch((error: any) => {
        setErrorMessage("Failed to Activate voucher.");
        setShowModal({ isVisible: true, color: false });
        setTimeout(() => {
          setShowModal({ isVisible: false, color: false });
        }, 1000);
      });
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    console.log("Search Input:", event.target.value);
  };

  const handleStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setStatus(value);
  };

  const formatVoucherType = (type: any) => {
    if (!type) return "";
    return type
      .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase ko space mein todta hai
      .replace(/^./, (str: any) => str.toUpperCase()); // pehle letter ko capitalize karta hai
  };

  const formatDateTimeLocal = (timestamp: number | string | Date) => {
    if (!timestamp) return "";

    const date = new Date(timestamp); // handles UTC string properly
    const pad = (n: number) => n.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`; // ✅ local time
  };
 const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };


  return (
    <div className="page-content Promotion-Main">
      <DeactiveModal
        show={deActiveModal}
        onCloseClick={() => setdeActiveModal(false)}
      />
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <Container fluid>
        <BreadCrumb
          title="Regular Voucher"
          pageTitle="promotion"
          pageTitleRoute="/promotion"
        />
        <Card className="PromotionCard-Main">
          <div className="regularVOucher">
            <div className="ticket">
              <div className="image">
                <img src={TicketIcon} alt="" />
              </div>
              <div className="regular">
                <h1>Regular Voucher </h1>
                <p>Increase traffic and drive sales</p>
                <Link to={"/create-voucher"}>
                  <button data-testing-id="Createvoucher_Promotion">
                    <i className="bx bx-plus-circle"></i> Create Voucher
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </Card>
        <Card className="PromotionCard-Main">
          <div className="selectMain">
            <select
              value={status}
              data-testing-id="statusSelect_PromotionListing"
              onChange={handleStatusChange}
            >
              <option
                value=""
                data-testing-id={
                  "selectStatusOption_PromotionListing" + props.index
                }
              >
                Select Status
              </option>
              <option
                value="active"
                data-testing-id={"activeOption_PromotionListing" + props.index}
              >
                Active
              </option>
              <option
                value="inActive"
                data-testing-id={
                  "inactiveOption_PromotionListing" + props.index
                }
              >
                In Active
              </option>
            </select>
            <select name="" id="">
              <option value="" data-testing-id="Collectible_promotino">
                Collectible{" "}
              </option>
            </select>
            <div className="searchAndSelect">
              <select name="" id="">
                <option value="">Voucher Name</option>
              </select>
              <div className="input">
                <input
                  data-testing-id="voucherSearch_promotion"
                  type="text"
                  placeholder="Voucher Name/ID"
                  value={keyword}
                  onChange={handleSearchChange}
                />
                <img src={searchIcon} alt="" />
              </div>
            </div>
          </div>
          <div className="TablePromotion-main">
            <table className="w-100">
              <thead>
                <tr>
                  <th>
                    <p>Basic Info </p>
                  </th>
                  <th>
                    <p>Collect Start Time </p>
                  </th>
                  <th>
                    <p> Redeem End Time</p>
                  </th>
                  <th>
                    <p>Discount Apply To</p>
                  </th>
                  <th>
                    <p>Vouchers Collected</p>
                  </th>
                  <th>
                    <p>Voucher Type</p>
                  </th>
                  {/* <th>
                    <p>Discount Details</p>
                  </th> */}
                  <th>
                    <p>Active</p>
                  </th>
                  <th>
                    <p>Status</p>
                  </th>
                  <th>
                    <div className="d-flex gap-1">
                      <img src={FilterIcon} alt="" />
                      <p className="text-secondary">Action</p>
                    </div>
                  </th>
                </tr>
              </thead>
              {Array.isArray(data?.data) ? (
                data.data.map((voucher: any, index: number) => (
                  <tbody>
                    <tr key={index}>
                      <td>
                        <div className="d-flex gap-2">
                          <input
                            type="checkbox"
                            className="sellerCheckbox m-0 form-check-input"
                            data-testing-id={
                              "selectAllInput_BlockedKeyword" + index
                            }
                          />
                          <p>
                            <span>{voucher?.promotionName || "Cap brown"}</span>
                          </p>
                        </div>
                      </td>
                      <td>
                        <p>
                          {formatDateTimeLocal(voucher?.collectStartTime)}
                        </p>
                      </td>
                      <td>
                        <p>
                          {formatDateTimeLocal(voucher?.redeemEndPeriod)}
                        </p>
                      </td>
                      <td>
                        <p>{formatVoucherType(voucher?.voucherType) || "--"}</p>
                      </td>
                      <td>
                        <p>
                          {voucher?.discountType === 'flatDiscount'
                            ? 'Flat Discount'
                            : voucher?.discountType === 'percentage'
                              ? 'Percentage'
                              : ''}
                        </p>
                      </td>

                      <td>
                        <p>{formatVoucherType(voucher?.voucherType) || "--"}</p>
                      </td>
                      {/* <td>
                        <p>
                          Discount would be: <br /> {voucher?.discount || "4%"} if order value <br /> reaches Rs.
                          {voucher?.minimumAmount || "2500"}.
                        </p>
                      </td> */}
                      <td>
                        <p>
                          {voucher?.isActive ? "Yes" : "No"}
                        </p>
                      </td>
                      <td>
                        <a>{formatVoucherType(voucher?.status || "Active")}</a>
                      </td>
                      <td>
                        <div className="icon-main">
                          <div
                            data-testing-id={"edit" + index}
                            className="d-flex gap-2 align-items-center"
                            onClick={() =>
                              navigate(`/create-voucher/${voucher._id}`)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <img src={editIcon} alt="" />
                            <h6>Edit</h6>
                          </div>
                          <div
                            style={{
                              cursor: !voucher?.productIds?.length
                                ? "not-allowed"
                                : "pointer",
                            }}
                            className="d-flex gap-2 align-items-center"
                            data-testing-id={"Manage" + index}
                            onClick={() => {
                              if (voucher?.productIds?.length) {
                                navigate(`/Manage-product/${voucher._id}`, {
                                  state: {
                                    isManege: true,
                                  },
                                });
                              }
                            }}
                          >
                            <img src={settingIcon} alt="" />
                            <h6>Manage</h6>
                          </div>

                          <div
                            data-testing-id={"Duplicate" + index}
                            className="d-flex gap-2 align-items-center"
                            onClick={() =>
                              navigate(`/create-voucher/${voucher._id}`, {
                                state: {
                                  duplicateData: voucher,
                                  isDuplicate: true,
                                },
                              })
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <img src={duplicateIcon} alt="" />
                            <h6>Duplicate</h6>
                          </div>
                          <div className="d-flex gap-2 align-items-center">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={voucher.isActive} // reflect the current status
                                data-testing-Id={
                                  "activeToggle_manageProducts" + index
                                }
                                onChange={() => handleToggle(voucher._id)}
                              />
                            </div>
                            <h6>
                              {voucher.isActive ? "Deactivate" : "Activate"}
                            </h6>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>

                ))
              ) : (
                <tbody>
                  <tr>
                    <td className="nodata" colSpan={10}>
                      No Data Found
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
                {/* {totalPages > 1 && ( */}
                  <div className="d-flex  justify-content-end">
                     <div className="d-flex justify-content-center mobile-hide">
                
                   <div className="paginationDv mobile-show ">
                <nav aria-label="Page navigation example" 
                 style={{
                          background: "white",
                          padding: "5px 5px",
                          borderRadius: "4px",
                          border: "1px solid #0877FF",
                          display: "flex",
                          alignItems: "center",
                        }}>
                             <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="me-2">
                         <option value={20}>20</option>
                         <option value={50}>50</option>
                         <option value={80}>80</option>
                         <option value={100}>100</option>
                       </select>
                           <h1
                          style={{
                            color: "#111417",
                            margin: "0px 15px 0px 10px",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                          >
                          Total {data?.data?.length} 
                        </h1>
                  <ul className="pagination detailPagepagi">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        style={{
                          height: "26px",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        className="page-link"
                        data-testing-id={"pagination" + currentPage}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        <i
                          style={{ height: "11px" }}
                          className="bx bxs-left-arrow"
                        ></i>
                      </button>
                    </li>
                   {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
  let startPage = 1;

  if (totalPages <= 5) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 4;
  } else {
    startPage = currentPage - 2;
  }

  return startPage + i;
                    }).map((page) => (
                      <div>
                        <li
                          className={`page-item ${
                            currentPage === page ? "active" : ""
                          }`}
                          key={page}
                        >
                          <button
                            style={{ height: "26px" }}
                            className="page-link orderPg"
                            onClick={() => setCurrentPage(page)}
                            data-testing-id={"pagination" + currentPage}
                          >
                            {page}
                          </button>
                        </li>
                      </div>
                    ))}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link orderPg"
                        style={{
                          height: "26px !important",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                      >
                        <i
                          className="bx bxs-right-arrow"
                          style={{ width: "6px", height: "11px" }}
                        ></i>
                      </button>
                    </li>
                                              <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    style={{
      margin: "0 10px",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "13px",
    }}
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
      <option key={pageNum} value={pageNum}>
        Page {pageNum}
      </option>
    ))}
  </select>
                  </ul>
                </nav>
              </div>
               </div>
                  </div>
                {/* )} */}
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default PromotionListing;
